<template>
	<div class="FilshCourseModalWarp">
		<el-dialog title="" :visible.sync="certificateVisible" width="720px" class="dialogWarp" @closed="offmodalFn" :destroy-on-close="true" :close-on-click-modal='false'
		    :append-to-body="true">
			<div class="singupdialogcenter">
				<div class="title">
					成绩证书
				</div>
				<div v-if="src">
					<pdf  ref="pdf" :src="src" :rotate="pageRotate"></pdf>
				</div>
				
				<div class="formBtnBox">
					<el-button type="primary" @click="downloadFn" class="downBtn"  v-if="src">下载</el-button>
					<el-button @click="offmodalFn" class="cancelBtn">取消</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import pdf from "vue-pdf";
export default {
	components: {
		pdf,
	},
	props: ['isShow','currentData'],
	data() {
		return {
			certificateVisible: true,
			src: null,
			currentPage: 1, // pdf文件页码
			pageCount: 1, // pdf文件总页数
			scale: 100,
			pageRotate: 0,
		}
	},
	created() {
		let d = "";
		this.src = pdf.createLoadingTask({
			url: `${process.env.VUE_APP_WZ}/upload/download?session=${this.currentData.certificateUrl}`,
			httpHeaders: { Authorization: sessionStorage.getItem("token") },
		});
	},
	methods: {
		// 关闭表单
		offmodalFn() {
			// this.$emit('certificateShowModal', false)
			this.$emit('update:isShow', false)
			if (!this.isCustom) this.$destroy() // 销毁当前组件
		},
		// pdf加载时
		// 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
		changePdfPage(val) {
			if (val === 0 && this.currentPage > 1) {
				this.currentPage--;
			}
			if (val === 1 && this.currentPage < this.pageCount) {
				this.currentPage++;
			}
		},
		//放大
		scaleD() {
			this.scale += 5;
			this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
		},
		//缩小
		scaleX() {
			if (this.scale === 100) {
				return;
			}
			this.scale += -5;
			this.$refs.pdf.$el.style.width = parseInt(this.scale) + "%";
		},
		// 顺时针
		clock() {
			this.pageRotate += 90;
		},
		// 逆时针
		counterClock() {
			this.pageRotate -= 90;
		},
		downloadFn(){
			let Docurl = `${process.env.VUE_APP_GATEWAY}${'/upload/download?session='}${this.currentData.certificateUrl}`
            window.open(Docurl)
		},
	}
}
</script>
<style lang="less" scoped>
.dialogWarp {
	/deep/.singupdialogcenter {
		padding: 17px 60px 0px 60px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;
		align-items: center;
		.title {
			font-size: 22px;
			line-height: 54px;
			color: #43424b;
		}
		.textbox {
			font-size: 16px;
			line-height: 30px;
			color: #666666;
			margin-bottom: 120px;
		}

		.formBtnBox {
			display: flex;
			fill-opacity: row;
			justify-content: center;
			cursor: pointer;
			margin-top: 70px;
			.downBtn {
				width: 152px;
				height: 40px;
				background: #349cff;
				margin: 0 20px;
				cursor: pointer;
			}
			.cancelBtn {
				width: 152px;
				height: 40px;
				border: 1px solid #a6a9b7;
				border-radius: 5px;
				margin: 0 20px;
			}
		}
	}
}
</style>


